var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIconGolden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M23.415,10.3H16.192L14,3.885a.8.8,0,0,0-1.493,0l-2.2,6.413H3.036a.78.78,0,0,0-.786.769.554.554,0,0,0,.015.13.736.736,0,0,0,.329.543l5.937,4.1L6.252,22.322a.834.834,0,0,0,.712,1.053.976.976,0,0,0,.491-.173l5.795-4.043L19.045,23.2a.933.933,0,0,0,.491.173.713.713,0,0,0,.437-.187.753.753,0,0,0,.27-.865l-2.279-6.486L23.852,11.7l.142-.12a.8.8,0,0,0,.255-.514A.824.824,0,0,0,23.415,10.3Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#ffd711"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconGolden);
export default __webpack_public_path__ + "static/media/star-icon-golden.2b42bf7c5dac0ab7f01e7fac67b839e2.svg";
export { ForwardRef as ReactComponent };